import { ColumnsType } from 'antd/es/table';
import {
  Col,
  Row,
  Table,
  Divider,
  Tag,
  Input,
  Modal,
  Collapse,
  Popover,
  Space,
  Form,
  Select,
  Slider,
  Spin,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { MainLayout } from 'components';
import Button from 'components/Button';
import { useEffect, useRef, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import {
  AlertBlue,
  FilterGoldIcon,
  FilterIcon,
  OrderStar,
  SendApproval,
  ValidateFail,
  ValidateSuccess,
} from 'assets/svg';
import CartApi from 'apis/CartApi';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { useUser } from 'contexts/User';
import { openNotificationWithIcon } from 'utils/notification';
import { HocChangePagination } from 'utils/HocChangePagination';
import ProductCartInfo from 'components/Modules/Cart/CartTVV/ProductCartInfo';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import CapitalApi from 'apis/CapitalApi';
import AllocateApi from 'apis/AllocateApi';
import { defaultImage, logo } from 'assets/images';
import { CloseOutlined, UpOutlined } from '@ant-design/icons';
import { DownOutlined } from '@ant-design/icons';
import { CollapseProps } from 'antd/lib';
import { useForm } from 'antd/es/form/Form';
import ProductApi from 'apis/ProductApi';
import { PageTitle } from 'constants/title';

type FixedType = 'left' | 'right' | boolean;

export default function TVVCheckCart() {
  document.title = PageTitle;

  const { user } = useUser();
  const history = useHistory();
  const [cartOrderTVV, setCartOrderTVV] = useState<any[]>([]);
  const [total, setTotal] = useState<number>();
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const queryParam = useQueryParam();

  const [totalPrice, setTotalPrice] = useState<number>();
  const [validateLoading, setValidateLoading] = useState<boolean>(false);
  const [dataDelete, setDataDelete] = useState<any>();
  const [modalData, setModalData] = useState<any>(null);
  const [minRegister, setMinRegister] = useState<any>();
  const [maxRegister, setMaxRegister] = useState<any>();
  const [minQuantity, setMinQuantity] = useState<any>();
  const [maxQuantity, setMaxQuantity] = useState<any>();
  const [dataCapitalProducts, setDataCapitalProducts] = useState<any>();
  const [dataDongHang, setDataDongHang] = useState<any[]>();
  const [capitalYear, setCapitalYear] = useState<number | null>(null);
  const [isCapitalYearLoaded, setIsCapitalYearLoaded] = useState(false);

  const [modalSendApproval, setModalSendApproval] = useState(false);
  const [modalConfirmDelete, setModalConfirmDelete] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataValidate, setDataValidate] = useState<any[]>();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const [searchName, setSearchName] = useState<any>();
  const [nhanhangSelected, setNhanHang] = useState<any>([]);
  const [donghangSelected, setDongHang] = useState<any>([]);
  const [nganhhangSelected, setNganhHang] = useState<any>([]);
  const [chungloaiSelected, setChungLoai] = useState<any>([]);
  const [isBoCap, setBoCap] = useState<any>();
  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const [bstSelected, setBST] = useState<any>();
  const modalRef = useRef();

  const [isOpenFilterAdvanced, setIsOpenFilterAdvanced] =
    useState<boolean>(false);
  const toggleFilterAdvanced = () => {
    setIsOpenFilterAdvanced(!isOpenFilterAdvanced);
  };

  const { Option } = Select;
  const [form] = useForm();

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const pagination = { page: page, page_size: page_size };
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  interface Iparam {
    id: string;
  }
  const { id } = useParams<Iparam>();
  const cart_register_id = parseInt(id);

  const { data: cartAllocated, isLoading: getIdLoading } = useQuery(
    ['get'],
    () => CartApi.getCartAllocated()
  );

  const cart_name = (cartAllocated?.data || []).filter((item: any) => {
    return item?.cart_register_id === cart_register_id;
  });

  useEffect(() => {
    const branchCodeRaw = user?.branch_code ?? user?.plantCode;
    const branchCode =
      branchCodeRaw !== undefined && branchCodeRaw !== null
        ? String(branchCodeRaw)
        : undefined;

    if (!branchCode) {
      const currentYear = new Date().getFullYear();
      setCapitalYear(currentYear);
      setIsCapitalYearLoaded(true);
      return;
    }

    const fetchMaxCapitalYear = async () => {
      try {
        const response = await AllocateApi.getMaxCapitalYear(branchCode);
        const maxCapitalYear =
          response?.data?.data?.max_capital_year ??
          response?.data?.max_capital_year;

        if (maxCapitalYear !== undefined && maxCapitalYear !== null) {
          const parsedYear = Number(maxCapitalYear);
          if (!Number.isNaN(parsedYear)) {
            setCapitalYear(parsedYear);
            return;
          }
        }
        setCapitalYear(new Date().getFullYear());
      } catch (error) {
        setCapitalYear(new Date().getFullYear());
      } finally {
        setIsCapitalYearLoaded(true);
      }
    };

    fetchMaxCapitalYear();
  }, [user?.branch_code, user?.plantCode]);

  useEffect(() => {
    setTitle(`${cart_name[0]?.cart_name}`);
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/product-register">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/product-register">Đặt hàng</a>
          </p>
        ),
      },
      { title: <a>{cart_name[0]?.cart_name}</a> },
    ]);
  }, [cart_name, id]);

  const params = {
    page: page.toString(),
    page_size: page_size.toString(),
    shop_id: user?.plantId,
    cart_register_id: cart_register_id,
    ...(searchName && { ten_mau: searchName }),
    ...(nhanhangSelected &&
      nhanhangSelected.length != 0 && { nhan_hang: nhanhangSelected }),
    ...(donghangSelected &&
      donghangSelected.length != 0 && { dong_hang: donghangSelected }),
    ...(nganhhangSelected &&
      nganhhangSelected.length != 0 && { nganh_hang: nganhhangSelected }),
    ...(chungloaiSelected &&
      chungloaiSelected.length != 0 && { chung_loai: chungloaiSelected }),
    ...(isBoCap && isBoCap == 'is_group_bo' && { is_group_bo: true }),
    ...(isBoCap && isBoCap == 'is_group_cap' && { is_group_cap: true }),
    ...(bstSelected && { bst: bstSelected }),
    ...(formSubmitParams && formSubmitParams),
  };

  const { mutate: refetch, isLoading } = useMutation(
    () => CartApi.getCartTVV_view(params),
    {
      onSuccess: (res: any) => {
        setCartOrderTVV(res.data);
        setTotal(res?.total);
        setMinRegister(res.sum_min_cost_price);
        setMaxRegister(res.sum_max_cost_price);
        setMinQuantity(res.sum_order_min);
        setMaxQuantity(res.sum_order_max);
        setDataDongHang(res?.data_dong_hang);
        let price = 0;
        for (let i = 0; i < res.data.length; i++) {
          price = price + res.data[i].price * res.data[i].order_max;
        }
        setTotalPrice(price);
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e);
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [
    user?.plantId,
    page,
    page_size,
    searchName,
    formSubmitParams,
    nhanhangSelected,
    donghangSelected,
    nganhhangSelected,
    chungloaiSelected,
    isBoCap,
    bstSelected,
    id,
  ]);

  const deleteProdct = (id: number) => {
    CartApi.deleteCartTVV(id)
      .then((res) => {
        console.log(res);
        refetch();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(
        ([_, value]) =>
          value !== undefined && !(Array.isArray(value) && value.length === 0)
      )
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (
        key == 'plhh' ||
        key == 'dong_hang' ||
        key == 'nganh_hang' ||
        key == 'chung_loai' ||
        key == 'loai_da' ||
        key == 'nhom_da' ||
        key == 'line_xman' ||
        key == 'material_type' ||
        key == 'kldg_3tc'
      ) {
        stringifiedData[key] = filteredData[key];
      } else if (key == 'cost_price') {
        const values: any = filteredData[key];
        stringifiedData['min_cost_price'] = values[0];
        stringifiedData['max_cost_price'] = values[1];
      } else if (key == 'price') {
        const values: any = filteredData[key];
        stringifiedData['min_price'] = values[0];
        stringifiedData['max_price'] = values[1];
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    console.log('stringifiedData', stringifiedData);
    setFormSubmitParams(stringifiedData);
    history.push(`/order/tvv-view/${id}`, {
      page: 1,
      page_size: page_size,
    });
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const requestApprovalToCHT = () => {
    if (!isCapitalYearLoaded || capitalYear === null) {
      openNotificationWithIcon('warning', 'Vui lòng chờ tải năm vốn');
      return;
    }
    setModalSendApproval(false);
    setValidateLoading(true);
    CartApi.requestApprovalToCHT(
      cartOrderTVV[0].cart_order_tvv_id,
      capitalYear ?? undefined
    )
      .then((res) => {
        setValidateLoading(false);
        openNotificationWithIcon('success', 'Gửi yêu cầu thành công');
        history.push('/product-register');
      })
      .catch((err) => {
        setValidateLoading(false);
        openNotificationWithIcon('error', err.toString());
      });
  };

  const { isLoading: capitalDataLoading } = useQuery(
    ['getCapitalShop', user?.plantId, id, capitalYear],
    () =>
      CapitalApi.getCapitalShop(
        user?.plantId ?? 0,
        capitalYear ?? new Date().getFullYear()
      )
        .then((res) => {
          setDataCapitalProducts(res.data.product_capital_info);
        })
        .catch((err) => {
          console.log(err);
        }),
    {
      enabled: isCapitalYearLoaded && !!user?.plantId,
    }
  );

  const { data: lstProductOption } = useQuery(
    ['getProductOption'],
    () => ProductApi.getProductOption() // lấy ds option
  );

  const pthh_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'plhh'
  );
  const plhh =
    pthh_list == undefined || pthh_list.length == 0 ? [] : pthh_list[0]['list'];

  const donghang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'line_xman'
  )[0]['list'];

  const nganhhang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nganhhang'
  )[0]['list'];

  const chungloai = lstProductOption?.data?.filter(
    (option: any) => option.type === 'chungloai'
  )[0]['list'];

  const bst = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bst'
  )[0]['list'];

  const phankhuc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phankhuc'
  )[0]['list'];

  const costprice = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cost_price'
  )[0]['data'];

  const price = lstProductOption?.data?.filter(
    (option: any) => option.type === 'price'
  )[0]['data'];

  const loaida = lstProductOption?.data?.filter(
    (option: any) => option.type === 'loai_da'
  )[0]['list'];

  const nhomda = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nhom_da'
  )[0]['list'];

  const donghangsap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'donghang'
  )[0]['list'];

  const gioitinh = lstProductOption?.data?.filter(
    (option: any) => option.type === 'gioitinh'
  )[0]['list'];

  const bo = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bo'
  )[0]['list'];

  const cap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cap'
  )[0]['list'];

  const xman = lstProductOption?.data?.filter(
    (option: any) => option.type === 'xman'
  )[0]['list'];

  const kldg_3tc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'kldg_3tc'
  )[0]['list'];

  const materialtype_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'material_type'
  );

  const materialtype =
    materialtype_list == undefined || materialtype_list.length == 0
      ? []
      : materialtype_list[0]['list'];

  function ChangeValueMax(event: any, record: any) {
    updateProductInfo(record, undefined, parseInt(event.target.value));
  }

  function ChangeValueMin(event: any, record: any) {
    updateProductInfo(record, parseInt(event.target.value), undefined);
  }

  function updateProductInfo(record: any, min?: number, max?: number) {
    const params = {
      cart_order_tvv_id: record.cart_order_tvv_id,
      cart_order_tvv_dt_id: record.cart_order_tvv_dt_id,
      order_tvv_detail: {
        cart_register_detail_id: record.cart_register_detail_id,
        order_min: min ?? record.order_min,
        order_max: max ?? record.order_max,
        list_order_size: [],
      },
    };

    if (params.order_tvv_detail.order_min > params.order_tvv_detail.order_max) {
      openNotificationWithIcon('error', 'Max phải lớn hơn hoặc bằng Min');
      const updatedList = cartOrderTVV.map((product) => {
        if (
          product.cart_register_detail_id === record.cart_register_detail_id
        ) {
          return {
            ...product,
            order_min: min ?? record.order_min,
            order_max: max ?? record.order_max,
          };
        }
        return product;
      });
      setCartOrderTVV(updatedList);
    } else {
      CartApi.updateProductCart(params)
        .then((res) => {
          openNotificationWithIcon('success', 'Cập nhật thành công');
          const updatedList = cartOrderTVV.map((product) => {
            if (
              product.cart_register_detail_id === record.cart_register_detail_id
            ) {
              return {
                ...product,
                order_min: min ?? record.order_min,
                order_max: max ?? record.order_max,
              };
            }
            return product;
          });
          setCartOrderTVV(updatedList);
        })
        .catch((err) => {
          openNotificationWithIcon('error', err.toString());
        });
    }
  }

  const CheckValidate = (id: any) => {
    setValidateLoading(true);

    CartApi.checkValidate(id)
      .then((res) => {
        if (res.data === 'success') {
          setDataValidate([{ type: '', message: '' }]);
        } else {
          setDataValidate(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setValidateLoading(false);
      });
  };

  const convertStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
      case 0:
        return 'Mới tạo';
      case 1:
        return 'TVV duyệt gửi CHT';
      case 2:
        return 'CHT từ Chối';
      case 3:
        return 'CHT duyệt gửi CN';
      case 4:
        return 'CN từ Chối';
      case 5:
        return 'CN duyệt gửi HS';
      case 6:
        return 'HS từ chối';
      case 7:
        return 'HS duyệt';
      default:
        return '-';
    }
  };

  const renderOrderMax = () => {
    const max = maxRegister || 0;

    if ((dataValidate || [])?.length > 0) {
      const dataCheck = dataValidate?.find((item) => {
        return item.type === 'max-price';
      });
      if (dataCheck === undefined) {
        return (
          <span className="flex items-center gap-1">
            {formatCurrencyVND(max)} <ValidateSuccess />
          </span>
        );
      } else
        return (
          <span className="flex items-center gap-1 text-red-500">
            {formatCurrencyVND(max)}{' '}
            <Popover
              content={<div className="font-bold">{dataCheck.message}</div>}
            >
              <ValidateFail />
            </Popover>
          </span>
        );
    } else return <span>{formatCurrencyVND(max)}</span>;
  };

  const renderOrderMin = () => {
    const min = minRegister || 0;

    if ((dataValidate || [])?.length > 0) {
      const dataCheck = dataValidate?.find((item) => {
        return item.type === 'min-price';
      });
      if (dataCheck === undefined) {
        return (
          <span className="flex items-center gap-1 ">
            {formatCurrencyVND(min)} <ValidateSuccess />
          </span>
        );
      } else
        return (
          <span className="flex items-center gap-1 text-red-500">
            {formatCurrencyVND(min)}{' '}
            <Popover
              placement="topRight"
              content={<div className="font-bold">{dataCheck.message}</div>}
            >
              <ValidateFail />
            </Popover>
          </span>
        );
    } else return <span>{formatCurrencyVND(min)}</span>;
  };

  const renderValidateSet = (pof_code: string) => {
    const result = dataValidate?.filter((item) => {
      return item.product_code?.includes(pof_code);
    });

    if (result?.length === 0) {
      return '';
    } else {
      if ((result || [])[0]?.type === 'bo') {
        return (
          <>
            <p className="flex items-center gap-2 mt-4 font-bold">
              <ValidateFail /> Điều kiện đặt hàng chưa đúng:{' '}
              <span className="text-red-500">{(result || [])[0]?.message}</span>{' '}
            </p>

            <Row style={{ fontWeight: 'bold' }}>
              <Col span={4}>Các mã sản phẩm trong bộ:</Col>
              <Col>
                {(result || [])[0]?.product_code_full_list.map(
                  (item: any, index: any) => (
                    <Row className="text-primary-50" key={index}>
                      {item}
                    </Row>
                  )
                )}
              </Col>
            </Row>
          </>
        );
      }
      if ((result || [])[0]?.type === 'cap') {
        return (
          <>
            <p className="flex items-center gap-2 mt-4">
              <ValidateFail /> Điều kiện đặt hàng chưa đúng:{' '}
              <span className="text-red-500">{(result || [])[0]?.message}</span>{' '}
            </p>

            <p className="flex items-center gap-2 font-bold">
              <span>Các mã sản phẩm trong cặp:</span>
              {(result || [])[0]?.product_code_full_list.map((item: any) => (
                <Row key={item}>{item}</Row>
              ))}
            </p>
          </>
        );
      }
    }
  };

  const getCabinetCapital = (dong_hang: string) => {
    return dataCapitalProducts?.find(
      (item: any) => item.dong_hang === dong_hang
    )?.total_cabinet;
  };

  const renderValidateCapital = (item: any) => {
    if (dataValidate === undefined) {
      return (
        <Row>
          <Col className="text-sm text-neutral-50" span={6}>
            {item?.dong_hang || '-'}
          </Col>
          <Col span={18} className="text-sm flex items-center gap-1">
            : <>{formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}</> -{' '}
            <>{formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}</>,{' '}
            {getCabinetCapital(item?.dong_hang) || 0} tủ:{' '}
            <>{item?.sum_order_min.toFixed(0)}</> -{' '}
            <>{item?.sum_order_max.toFixed(0)}</> sp
          </Col>
        </Row>
      );
    } else {
      const check = dataValidate?.filter((dataValidate) => {
        return dataValidate.code === item.dong_hang;
      });

      if (check?.length === 0) {
        return (
          <Row>
            <Col className="text-sm text-neutral-50" span={6}>
              {item?.dong_hang || '-'}
            </Col>
            <Col span={18} className="text-sm flex items-center gap-1">
              : <>{formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}</> -{' '}
              <>{formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}</>,{' '}
              {getCabinetCapital(item?.dong_hang) || 0} tủ:{' '}
              <>{item?.sum_order_min.toFixed(0)}</> -{' '}
              <>{item?.sum_order_max.toFixed(0)}</> sp <ValidateSuccess />
            </Col>
          </Row>
        );
      } else {
        return (
          <Row>
            <Col className="text-sm text-neutral-50" span={6}>
              {item?.dong_hang || '-'}
            </Col>
            <Col span={18} className="text-sm flex items-center gap-1">
              :{' '}
              {check.find((items: any) => {
                return items.type === 'price_min_dong_hang';
              }) === undefined ? (
                <>{formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}{' '}
                  </strong>
                </>
              )}{' '}
              -{' '}
              {check.find((items: any) => {
                return items.type === 'price_max_dong_hang';
              }) === undefined ? (
                <>{formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}{' '}
                  </strong>
                </>
              )}
              , {getCabinetCapital(item?.dong_hang) || 0} tủ:{' '}
              {check.find((items: any) => {
                return items.type === 'total_min_dong_hang';
              }) === undefined ? (
                <>{item?.sum_order_min.toFixed(0)}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {item?.sum_order_min.toFixed(0)}{' '}
                  </strong>
                </>
              )}{' '}
              -{' '}
              {check.find((items: any) => {
                return items.type === 'total_max_dong_hang';
              }) === undefined ? (
                <>{item?.sum_order_max.toFixed(0)}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {item?.sum_order_max.toFixed(0)}{' '}
                  </strong>
                </>
              )}{' '}
              sp
              <Popover
                content={
                  <div className="font-bold">
                    {check.map((items: any) => {
                      return (
                        <>
                          {items.message} <br />
                        </>
                      );
                    })}
                  </div>
                }
              >
                <ValidateFail />
              </Popover>
            </Col>
          </Row>
        );
      }
    }
  };

  const checkSetValidate = (pof_code: string) => {
    return dataValidate?.filter((item) => {
      return item.product_code?.includes(pof_code);
    });
  };

  const columns: ColumnsType<any> = [
    {
      width: 1000,
      align: 'left',
      render(_: any, record: any) {
        return (
          <div>
            <Row>
              <Col span={4} className="flex items-center justify-center">
                <img
                  className="rounded-lg"
                  width="80px"
                  height="80px"
                  src={record?.image_default || defaultImage}
                  alt=""
                />
              </Col>

              <Col
                span={14}
                className="border-r-2 border-l-2 border-dashed px-2"
              >
                <Row className="text-base pt-2 text-neutral-40">
                  <div className="flex items-center">
                    <Tag color="#038F00" className="custom-tag">
                      <span className="text-base font-bold mt-4">Mới tạo</span>
                    </Tag>
                    {record?.ma_mau || '-'}
                  </div>
                </Row>
                <Row className="text-base py-2 font-bold text-primary-50">
                  {record?.ten_mau || '-'}
                </Row>
                <Row
                  className="text-base border-b-2 border-dashed pb-4"
                  justify={'start'}
                >
                  {'Giá vốn:'}
                  &nbsp;
                  <span className="text-secondary-50 font-bold">
                    {record?.cost_price
                      ? formatCurrencyVND(record?.cost_price)
                      : '-'}
                  </span>
                </Row>
                {/* --------------------------------- */}
                <Row className="my-2" gutter={35}>
                  <Col span={1}>
                    <OrderStar />
                  </Col>
                  <Col span={6}>
                    <Row className="text-sm text-neutral-50">
                      Đánh giá 3 tiêu chí
                    </Row>
                    <Row className="text-sm">{record?.kldg_3tc || '-'}</Row>
                  </Col>
                  {/* ----------------------------- */}
                  <Col span={1}>
                    <OrderStar />
                  </Col>
                  <Col span={6}>
                    <Row className="text-sm text-neutral-50">
                      Doanh thu 6 tháng
                    </Row>
                    <Row className="text-sm">{record?.doanhthu_6th || '-'}</Row>
                  </Col>
                  {/* ----------------------------- */}
                  <Col span={1}>
                    <OrderStar />
                  </Col>
                  <Col span={6}>
                    <Row className="text-sm text-neutral-50">Tồn hiện tại</Row>
                    <Row className="text-sm">{record?.tongsl_ton || '-'}</Row>
                  </Col>
                </Row>
                {/* ----------------------------------*/}
                <Row className="border-t-2 border-dashed pt-4">
                  <Col
                    onClick={() => {
                      modalRef?.current?.setData(record);
                      if (record) {
                        setModalData(record);
                      }
                      setIsModalVisible(true);
                    }}
                    className="text-primary-50 font-bold cursor-pointer"
                    span={7}
                  >
                    Xem chi tiết {'>'}
                  </Col>
                  <Col span={1}>
                    <Divider type="vertical" />
                  </Col>
                  {/* <Col
                    onClick={() => {
                      console.log('test');
                    }}
                    className="text-primary-50 font-bold cursor-pointer"
                    span={7}
                  >
                    Lịch sử đặt hàng
                  </Col>
                  <Col span={1}>
                    <Divider type="vertical" />
                  </Col> */}
                  {/* <Col
                    onClick={() => {
                      setModalConfirmDelete(true);
                      setDataDelete(record?.cart_order_tvv_dt_id);
                    }}
                    className="text-red-500 font-bold cursor-pointer"
                    span={7}
                  >
                    Xoá
                  </Col> */}
                </Row>
              </Col>

              <Col span={6} className="pl-2">
                <Row
                  justify={'space-between'}
                  className="border-b-2 border-dashed pb-2 mb-2"
                >
                  <Col>Ni</Col>
                  <Col className="font-bold">{record?.ni_sanpham}</Col>{' '}
                </Row>
                <Row
                  justify={'space-between'}
                  className="border-b-2 border-dashed pb-2 mb-2"
                >
                  <Col>Đăng ký cũ</Col>
                  <Col className="font-bold">
                    {record?.old_order_min} - {record?.old_order_max}
                  </Col>{' '}
                </Row>
                <Row
                  justify={'space-between'}
                  className="border-b-2 border-dashed pb-3 mb-2"
                >
                  <Col span={12}>Đăng ký hiện tại</Col>
                  <Col span={4}>
                    <Row justify={'center'}>Min</Row>
                    <Input
                      disabled
                      defaultValue={record.order_min}
                      style={{
                        height: '28px',
                        width: '100%',
                        borderRadius: '5px',
                        padding: '8px',
                        textAlign: 'center',
                      }}
                      onBlur={(event) => ChangeValueMin(event, record)}
                      onPressEnter={(event) => ChangeValueMin(event, record)}
                      min={0}
                      max={24}
                    ></Input>
                  </Col>
                  <Col span={4}>
                    <Row justify={'center'}>Max</Row>
                    <Input
                      disabled
                      defaultValue={record.order_max}
                      style={{
                        height: '28px',
                        width: '100%',
                        borderRadius: '5px',
                        padding: '8px',
                        textAlign: 'center',
                      }}
                      onBlur={(event) => ChangeValueMax(event, record)}
                      onPressEnter={(event) => ChangeValueMax(event, record)}
                      min={0}
                      max={24}
                    ></Input>
                  </Col>
                </Row>
                <Row justify={'end'}>Vốn tồn tạm tính</Row>
                <Row
                  justify={'end'}
                  className="text-base text-secondary-50 font-bold"
                >
                  {formatCurrencyVND(record?.cost_price * record?.order_min)} -{' '}
                  {formatCurrencyVND(record?.cost_price * record?.order_max)}
                </Row>
              </Col>
            </Row>

            {renderValidateSet(record?.pro_code)}
          </div>
        );
      },
    },
    {
      width: 0.1,
      fixed: 'right' as FixedType,
    },
  ];

  const renderItemBottom = () => {
    return (
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="px-4">
        {(dataDongHang || []).map((item: any, index: any) => (
          <Col key={index} span={12} className="my-1">
            {renderValidateCapital(item)}
          </Col>
        ))}
      </Row>
    );
  };

  const items_bottom: CollapseProps['items'] = [
    {
      key: '1',
      label: <p className="text-xl font-bold px-2">Vốn theo dòng hàng</p>,
      children: <div className="flex flex-col gap-2">{renderItemBottom()}</div>,
    },
  ];

  const checkBeforeSendApprove = async () => {
    if (
      cartOrderTVV.length == 0 ||
      cartOrderTVV[0].order_status == 1 ||
      cartOrderTVV[0].order_status == 3 ||
      cartOrderTVV[0].order_status == 5 ||
      cartOrderTVV[0].order_status == 7
    ) {
      openNotificationWithIcon(
        'error',
        'Không thế gửi phê duyệt đơn hàng',
        `${
          cartOrderTVV.length == 0
            ? 'Không có sản phẩm trong đơn hàng'
            : 'Đơn hàng đã được ' + convertStatus(cartOrderTVV[0].order_status)
        }`
      );
    } else {
      setValidateLoading(true);

      await CartApi.checkValidate(cartOrderTVV[0]?.cart_order_tvv_id)
        .then((res) => {
          if (res.data === 'success') {
            setModalSendApproval(true);
          } else {
            const check = res.data?.find((item: any) => {
              return item?.isCritical === true;
            });

            if (check === undefined) {
              setModalSendApproval(true);
            } else {
              let listBo = '';
              for (const param of res.data) {
                if (param.isCritical === true)
                  listBo = listBo + param.code + ', ';
              }
              if (listBo != '')
                openNotificationWithIcon(
                  'error',
                  'Các bộ chưa đăng ký đủ mẫu: ' + listBo
                );
              else
                openNotificationWithIcon(
                  'error',
                  'Không đủ điều kiện đặt hàng'
                );
            }
          }
        })
        .catch(() => {
          openNotificationWithIcon('error', 'Không thể gửi phê duyệt đơn hàng');
        })
        .finally(() => {
          setValidateLoading(false);
        });
    }
  };

  return (
    <Spin size="large" spinning={validateLoading}>
      <MainLayout isLoading={capitalDataLoading && isLoading && getIdLoading}>
        <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 24 }}>
          <Col span={4} className="flex items-center">
            <div
              className="text-[#00538F] text-base cursor-pointer"
              onClick={() => history.goBack()}
            >
              {'<'} Quay lại đăng ký
            </div>
          </Col>

          <Col className="flex justify-end" span={20}>
            {/* <Button
              bgColor="bg-white"
              color="text-primary-50"
              border="border-primary-50"
              onClick={() => {
                CheckValidate(cartOrderTVV[0]?.cart_order_tvv_id);
              }}
            >
              <AlertBlue />
              Check điều kiện
            </Button> */}
            <Button
              customClass="mx-2"
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
            <Button
              onClick={() => {
                checkBeforeSendApprove();
              }}
            >
              <SendApproval />
              Gửi phê duyệt
            </Button>
          </Col>
        </Row>

        <Row justify={'end'} style={{ marginTop: '20px' }}>
          <Tag color="blue">
            <strong
              style={{
                fontSize: '16px',
                paddingLeft: '10px',
                paddingRight: '10px',
              }}
            >
              {convertStatus(
                cartOrderTVV == undefined || cartOrderTVV?.length == 0
                  ? null
                  : cartOrderTVV[0].order_status
              )}
            </strong>
          </Tag>
        </Row>

        <Form
          form={form}
          layout="vertical"
          className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Content>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                <Form.Item name="ma_mau" label="Mã mẫu">
                  <Input placeholder="Nhập mã mẫu" className="" />
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="plhh" label="Phân loại hàng hóa">
                  <Select
                    size="middle"
                    placeholder="Chọn phân loại hàng hóa"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {plhh &&
                      plhh.map((item: any) => (
                        <Option key={item.plhh} value={item.plhh}>
                          {item.plhh}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="" span={6}>
                <Form.Item name="line_xman" label="Dòng hàng Xman">
                  <Select
                    size="middle"
                    placeholder="Chọn dòng hàng"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {donghang &&
                      donghang.map((item: any) => (
                        <Option
                          key={item.line_xman_text}
                          value={item.line_xman_text}
                        >
                          {item.line_xman_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="" span={6}>
                <Form.Item name="nganh_hang" label="Ngành hàng">
                  <Select
                    size="middle"
                    placeholder="Chọn ngành hàng"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {nganhhang &&
                      nganhhang.map((item: any) => (
                        <Option key={item.prod_grp2} value={item.prod_grp2}>
                          {item.prod_grp2_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                <Form.Item name="chung_loai" label="Chủng loại SAP">
                  <Select
                    size="middle"
                    placeholder="Chọn chủng loại"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {chungloai &&
                      chungloai.map((item: any) => (
                        <Option key={item.chungloai} value={item.chungloai}>
                          {item.chungloai + ' - ' + item.chungloai_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="kldg_3tc" label="Đánh giá TQ">
                  <Select
                    size="middle"
                    placeholder="Chọn đánh giá TQ"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {kldg_3tc &&
                      kldg_3tc.map((item: any) => (
                        <Option key={item.kldg_3tc} value={item.kldg_3tc}>
                          {item.kldg_3tc}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="cost_price" label="Giá vốn bình quân">
                  {costprice && (
                    <Slider
                      min={costprice?.min}
                      max={costprice?.max}
                      range
                      step={10}
                      tooltip={{
                        formatter: (value: any) => {
                          return formatCurrencyVND(value);
                        },
                      }}
                      defaultValue={[costprice?.min, costprice?.max]}
                    />
                  )}
                </Form.Item>
              </Col>
              {/* <Col className="" span={6}>
                    <Form.Item name="price" label="Giá bán">
                      {price && (
                        <Slider
                          min={price?.min}
                          max={price?.max}
                          range
                          step={10}
                          tooltip={{
                            formatter: (value: any) => {
                              return formatCurrencyVND(value);
                            },
                          }}
                          defaultValue={[price?.min, price?.max]}
                        />
                      )}
                    </Form.Item>
                  </Col> */}
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="flex justify-end" span={24}>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-white'}
                  onClick={toggleFilterAdvanced}
                >
                  Tìm kiếm nâng cao
                  {isOpenFilterAdvanced ? <UpOutlined /> : <DownOutlined />}
                </Button>
              </Col>
            </Row>

            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className={`items-center ${
                isOpenFilterAdvanced ? '' : 'hidden'
              } mt-4`}
            >
              <Col className="" span={6}>
                <Form.Item name="loai_da" label="Loại đá">
                  <Select
                    size="middle"
                    placeholder="Chọn loại đá"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {loaida &&
                      loaida.map((item: any) => (
                        <Option key={item.loai_da} value={item.loai_da}>
                          {item.loai_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="nhom_da" label="Nhóm đá">
                  <Select
                    size="middle"
                    placeholder="Chọn nhóm đá"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {nhomda &&
                      nhomda.map((item: any) => (
                        <Option key={item.nhom_da} value={item.nhom_da}>
                          {item.nhom_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* <Col className="" span={6}>
                    <Form.Item name="email" label="BST">
                      <Select placeholder={'Chọn BST'} size="middle" />
                    </Form.Item>
                  </Col> */}

              <Col className="" span={6}>
                <Form.Item name="dong_hang" label="Dòng hàng SAP">
                  <Select
                    size="middle"
                    placeholder="Nhập dòng hàng SAP"
                    allowClear
                    mode="multiple"
                    maxTagCount="responsive"
                  >
                    {donghangsap &&
                      donghangsap.map((item: any) => (
                        <Option key={item.prod_grp4} value={item.prod_grp4}>
                          {item.prod_grp4_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="zma_bo" label="Bộ">
                  <Select size="middle" placeholder="Chọn bộ" allowClear>
                    {bo &&
                      bo.map((item: any) => (
                        <Option key={item.zma_bo} value={item.zma_bo}>
                          {item.zma_bo_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className={`items-center ${
                isOpenFilterAdvanced ? '' : 'hidden'
              } mt-4`}
            >
              <Col className="" span={6}>
                <Form.Item name="zma_ts_cap" label="Cặp">
                  <Select size="middle" placeholder="Nhập cặp" allowClear>
                    {cap &&
                      cap.map((item: any) => (
                        <Option key={item.zma_ts_cap} value={item.zma_ts_cap}>
                          {item.zma_ts_cap_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="gioi_tinh" label="Giới tính">
                  <Select
                    size="middle"
                    placeholder="Chọn giới tính"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {gioitinh &&
                      gioitinh.map((item: any) => (
                        <Option key={item.gioitinh} value={item.gioitinh}>
                          {item.gioitinh_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="material_type" label="Material Type">
                  <Select
                    size="middle"
                    placeholder="Chọn Material Type"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {materialtype &&
                      materialtype.map((item: any) => (
                        <Option
                          key={item.material_type}
                          value={item.material_type}
                        >
                          {item.material_type}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="xman" label="Xman">
                  <Select size="middle" placeholder="Chọn Xman" allowClear>
                    {xman &&
                      xman.map((item: any) => (
                        <Option key={item.xman} value={item.xman}>
                          {item.xman}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
              <Col className="flex justify-end mt-4" span={8}>
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    onClick={handleReset}
                  >
                    Hủy
                  </Button>
                  <Button type="submit">Tìm kiếm</Button>
                </Space>
              </Col>
            </Row>
          </Content>
        </Form>

        {/* <Row className="my-5" justify="center">
          <Col span={24} className="bg-white">
            <Collapse
              expandIconPosition="right"
              ghost
              expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? 180 : 0} />
              )}
              size="small"
              items={items_bottom}
            />
          </Col>
        </Row> */}

        <Modal
          open={modalSendApproval}
          onCancel={() => {
            setModalSendApproval(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold">Gửi yêu cầu phê duyệt giỏ hàng</p>
            <Divider style={{ margin: '10px 0' }} />
            <div>
              <p className="text-base">
                Bạn có chắc muốn gửi yêu cầu phê duyệt giỏ hàng lên cửa hàng
                trưởng?
                <br />
                {/* <span className="text-red-500">
                Cảnh báo đang vượt đăng ký vốn phân bổ.
              </span> */}
              </p>
            </div>
            <Row justify="end" className="mt-4">
              <Button
                onClick={() => {
                  setModalSendApproval(false);
                }}
                customClass="text-neutral-50 mr-2"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button onClick={requestApprovalToCHT}>Gửi yêu cầu</Button>
            </Row>
          </Content>
        </Modal>

        {/* popup xác nhận xoá sản phẩm */}
        <Modal
          open={modalConfirmDelete}
          onCancel={() => {
            setModalConfirmDelete(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold">Xác nhận xoá sản phẩm</p>
            <Divider style={{ margin: '20px 0' }} />
            <div>
              <p className="text-base">Bạn có chắc muốn xoá sản phẩm này?</p>
            </div>
            <Row justify="end" className="mt-4">
              <Button
                onClick={() => {
                  setModalConfirmDelete(false);
                }}
                customClass="text-neutral-50 mr-2"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button
                onClick={() => {
                  setModalConfirmDelete(false);
                  deleteProdct(dataDelete);
                }}
              >
                Xoá
              </Button>
            </Row>
          </Content>
        </Modal>

        {/* popup xem chi tiết sản phẩm */}
        <Modal
          title={
            <span className="custom-modal-header">Thông tin sản phẩm</span>
          }
          visible={isModalVisible}
          width={'70%'}
          closeIcon={<CloseOutlined onClick={handleCancel} />}
          style={{ marginTop: '-75px' }}
          footer={null}
        >
          <Divider
            style={{
              borderTop: '1px solid rgba(0, 0, 0, 0.2)',
              marginTop: '8px',
              marginBottom: '0px',
            }}
          />
          <ProductCartInfo
            ref={modalRef}
            data={modalData}
            setMin={modalData?.order_min}
            setMax={modalData?.order_max}
          />
          <div
            className="flex justify-end"
            style={{
              backgroundColor: '#EFF3F8',
              padding: '16px 36px',
              margin: '-20px -24px',
            }}
          >
            <Button customClass="end" onClick={handleCancel}>
              Đóng lại
            </Button>
          </div>
        </Modal>

        <Content className="main-content mt-5">
          <Row className="bg-neutral-95 rounded p-5">
            <Col span={8}>
              <p className="text-base font-bold">
                Tổng: <span className="text-primary-50">{total}</span> <br />
                SL Min:{' '}
                <span className="text-primary-50">{minQuantity || 0}</span> món
                SL Max:{' '}
                <span className="text-primary-50">{maxQuantity || 0}</span> món
              </p>
            </Col>
            <Col
              span={16}
              className="font-bold flex text-base items-center gap-1 justify-end"
            >
              <p>Vốn tồn tạm tính:</p>
              <p>{renderOrderMin()}</p>
              <p>-</p>
              <p>{renderOrderMax()}</p>
            </Col>
          </Row>

          <Table
            rowKey={(record) => record.ma_mau}
            columns={columns}
            className="customTable mt-5"
            loading={isLoading}
            dataSource={cartOrderTVV}
            scroll={{ x: 758 }}
            rowClassName={(record: any) => {
              if ((checkSetValidate(record?.pro_code) || []).length > 0) {
                return 'ant-ActiveRow';
              } else {
                return '';
              }
            }}
            pagination={{
              className: 'flex items-center',
              current: page,
              pageSize: page_size,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              onChange: HocChangePagination(history),
            }}
          />
        </Content>
      </MainLayout>
    </Spin>
  );
}
